enum PsStatus {
    SUCCESS, 
    ERROR, 
    BLOCK_LOADING, 
    PROGRESS_LOADING, 
    NOACTION
}

export default PsStatus;